export default "__VITE_ASSET__DvSf56hH__"